import { render, staticRenderFns } from "./SongListAdd.vue?vue&type=template&id=31bef045&scoped=true&"
import script from "./SongListAdd.vue?vue&type=script&lang=js&"
export * from "./SongListAdd.vue?vue&type=script&lang=js&"
import style0 from "./SongListAdd.vue?vue&type=style&index=0&id=31bef045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bef045",
  null
  
)

export default component.exports